import * as ActionTypes from 'store/actionTypes';

const defaultState = {
    customerId: undefined
}

const CampaignCustomerFilter = (state = defaultState, action: any) => {
  switch(action.type) {
    case ActionTypes.SAVE_LICENCE_FILTER:
      return {...action.payload};
    default:
      return state;
  }
}

export default CampaignCustomerFilter;